(() => {
  const toggle = document.querySelector('[data-bbgm-menu-toggle]');
  const menu = document.querySelector('[data-bbgm-mobile-nav]');
  const closeSupportMenus = (restoreFocus = false) => {
    document.querySelectorAll('[data-bbgm-support-toggle]').forEach((button) => {
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (button.getAttribute('aria-expanded') === 'true' && restoreFocus) button.focus();
      button.setAttribute('aria-expanded', 'false');
      if (target) target.hidden = true;
    });
  };
  if (toggle && menu) toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu.classList.toggle('is-open', !open);
    menu.hidden = open;
    if (open) closeSupportMenus();
  });
  document.querySelectorAll('[data-bbgm-support-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target) return;
      const open = button.getAttribute('aria-expanded') === 'true';
      closeSupportMenus();
      button.setAttribute('aria-expanded', String(!open));
      target.hidden = open;
    });
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.bbgm-support-nav')) closeSupportMenus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSupportMenus(true);
  });
  document.querySelectorAll('[data-bbgm-address-toggle]').forEach((button) => button.addEventListener('click', () => {
    const target = document.getElementById(button.getAttribute('aria-controls'));
    if (!target) return;
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    target.hidden = open;
  }));
})();
